module.exports = __webpack_public_path__ + "img/Banner3中文.a1142e6c.png";